// Module: scroll-indicator - Embassy Terazza
// Controls visibility of the hero scroll indicator and floating scroll-to-top button based on page scroll

export default function initScrollIndicator() {
  const indicator = document.querySelector('.hero-bottom');
  const scrollTopBtn = document.querySelector('.scroll-to-top-btn');

  function update() {
    const scrollY = window.lenis ? window.lenis.scroll : window.scrollY;

    // Hide/show hero scroll helper
    if (indicator) {
      if (scrollY > 30) {
        indicator.classList.add('scroll-indicator-hidden');
      } else {
        indicator.classList.remove('scroll-indicator-hidden');
      }
    }

    // Hide/show floating scroll-to-top button (only visible when footer is in view)
    if (scrollTopBtn) {
      const footer = document.querySelector('.footer-section');
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        // If the top of the footer has entered the viewport
        if (footerRect.top < window.innerHeight) {
          scrollTopBtn.classList.add('is-visible');
        } else {
          scrollTopBtn.classList.remove('is-visible');
        }
      } else {
        scrollTopBtn.classList.remove('is-visible');
      }
    }
  }

  // Initial state
  update();

  let ticking = false;
  const handler = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', handler, { passive: true });
  if (window.lenis) {
    window.lenis.on('scroll', handler);
  }
}
